const fillUserFields = (fields: string[], values: any[], currentUser: User) => {
    const newFields = fields.reduce((acc, newField, i) => ({
      ...acc,
      [newField]: values[i]
    }), {});

    const finalFields = {
      ...currentUser,
      role: currentUser.role.id,
      ...newFields
    };
    //@ts-ignore
    delete finalFields.accounts;
    
    return finalFields;
};

export default fillUserFields;
